var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.16,183.326l-17.24-17.233c-10.453-10.461-27.415-10.452-37.868,0l-16.127,16.136l55.1,55.099 l16.135-16.126C514.613,210.741,514.613,193.787,504.16,183.326z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.474,178.378H64.86c10.199,0,18.474-8.274,18.474-18.49c0-10.208-8.275-18.482-18.474-18.482H18.474 C8.274,141.406,0,149.68,0,159.888C0,170.104,8.274,178.378,18.474,178.378z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 197.722,
    className: "st0",
    width: 34.583,
    height: 116.557
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.334,352.113c0-10.208-8.275-18.491-18.474-18.491H18.474C8.274,333.622,0,341.905,0,352.113 c0,10.207,8.274,18.482,18.474,18.482H64.86C75.059,370.595,83.334,362.32,83.334,352.113z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.594,
    y: 150.44,
    className: "st0",
    width: 155.624,
    height: 25.937
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.594,
    y: 245.543,
    className: "st0",
    width: 155.624,
    height: 25.938
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.594,
    y: 340.647,
    className: "st0",
    width: 95.104,
    height: 25.937
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.413,71.556c0.008-3.977,3.242-7.211,7.215-7.219h263.645c8.82,0.008,16.638,3.52,22.434,9.287 c5.767,5.8,9.283,13.619,9.292,22.434v132.194l34.583-34.583V96.058c-0.013-36.627-29.682-66.296-66.309-66.304H64.628 c-23.096,0.017-41.785,18.71-41.798,41.802v50.507h34.583V71.556z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.998,415.943c-0.009,8.814-3.525,16.633-9.292,22.424c-5.796,5.775-13.614,9.288-22.434,9.296H64.628 c-3.973-0.008-7.206-3.242-7.215-7.218v-50.507H22.83v50.507c0.013,23.092,18.702,41.785,41.798,41.801h263.645 c36.627-0.008,66.296-29.677,66.309-66.303v-58.274l-34.583,34.583V415.943z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "281.81,333.344 281.81,388.443 336.911,388.443 472.997,252.357 417.897,197.257  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemo);
export default __webpack_public_path__ + "static/media/memo.f11e8ccfd738f79832c3e06f3d40a368.svg";
export { ForwardRef as ReactComponent };